/**
 * Use cases: edit customer details + reassign plan.
 */
import type { CustomerDetail } from '@domain/customer/Customer';
import type {
  CustomerEditableFields,
  CustomerRepository,
} from '@domain/customer/CustomerRepository';

export class InvalidCustomerEdit extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidCustomerEdit';
  }
}

export const editCustomer = (repo: CustomerRepository) =>
  async (
    id: string,
    fields: CustomerEditableFields,
  ): Promise<CustomerDetail> => {
    // Drop empty/undefined keys so we don't overwrite with empty strings.
    const clean: CustomerEditableFields = {};
    for (const [k, v] of Object.entries(fields)) {
      if (v !== undefined && v !== null) {
        (clean as Record<string, string>)[k] = v;
      }
    }
    if (Object.keys(clean).length === 0) {
      throw new InvalidCustomerEdit('no editable fields supplied');
    }
    return repo.patch(id, clean);
  };

export const changePlan = (repo: CustomerRepository) =>
  async (
    id: string,
    planId: string,
    reason: string,
  ): Promise<CustomerDetail> => {
    if (!planId) throw new InvalidCustomerEdit('plan_id required');
    if (!reason || !reason.trim()) {
      throw new InvalidCustomerEdit('reason required for plan change');
    }
    return repo.changePlan(id, planId, reason.trim());
  };
